export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PRICE = 45;
export const PRODUCT_NAME = "The Summit Hoodie";
export const SIZES = ["XS", "S", "M", "L", "XL", "XXL", "XXXL"];

export const COLOURS = [
  { id: "black", label: "Black", swatch: "#0b0b0d", product: "/images/p-black.jpg", model: "/images/portrait.jpg", tag: "Primary" },
  { id: "navy", label: "Navy", swatch: "#1b2a4a", product: "/images/p-navy.jpg", model: "/images/duo.jpg", tag: "Optional" },
  { id: "grey", label: "Grey", swatch: "#a9acb1", product: "/images/p-grey.jpg", model: "/images/duo.jpg", tag: "Optional" },
  { id: "white", label: "White", swatch: "#f2f2f0", product: "/images/p-white.jpg", model: "/images/white-model.jpg", tag: "Optional" },
];

export const colourById = (id) => COLOURS.find((c) => c.id === id) ?? COLOURS[0];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.16, 1, 0.3, 1];
